import { render, staticRenderFns } from "./DefiMintingMessage.vue?vue&type=template&id=60429e9e&"
import script from "./DefiMintingMessage.vue?vue&type=script&lang=js&"
export * from "./DefiMintingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports